import React from 'react';
import {FormControl, Textarea, FormHelperText} from '@chakra-ui/react';
import {AiFieldDefinitionConfig} from '../../../shared/fields/enrichment';
import {ConfigFormLabel} from './ConfigFormLabel';

export const KeyClarificationsEditor = ({
  config,
  isDisabled = false,
  onConfigChange,
}: {
  config: AiFieldDefinitionConfig;
  isDisabled?: boolean;
  onConfigChange: (config: AiFieldDefinitionConfig) => void;
}) => {
  return (
    <FormControl>
      <ConfigFormLabel>Key Clarifications (optional)</ConfigFormLabel>
      <Textarea
        isDisabled={isDisabled}
        onChange={(e) => {
          onConfigChange({
            ...config,
            clarifications: e.target.value.split('\n'),
          });
        }}
        placeholder="Add additional instructions for your AI Analyst..."
        rows={5}
        value={config.clarifications?.join('\n') ?? ''}
      />
      <FormHelperText textColor="kgray.300">
        Add a new line for each instruction you&apos;d like your AI Analyst to
        take into consideration.
      </FormHelperText>
    </FormControl>
  );
};
